import * as React from 'react'
import {injectIntl, FormattedMessage, useIntl, WrappedComponentProps} from 'react-intl'
import './LoginHelpModal.scss'
import {Modal, Elements} from "@tfo/common";
import classnames from "classnames";
const { Heading4 } = Elements

const LoginHelpModal: React.FunctionComponent<Modal.ModalProps & {
	showHelpModal: boolean
} & WrappedComponentProps> = props => {
	const {showHelpModal, onCloseClick} = props
	
	if (!showHelpModal) return null
	
	return (
		<Modal.Modal
			className={classnames('LoginHelpModal')}
			onCloseClick={onCloseClick}
			large
		>
			<div className="LoginHelpModalContainer">
				<Heading4 className="LoginHelpModalHeader">
					<FormattedMessage id="login.help.title"/>
				</Heading4>
				<div className="LoginHelpModalContent">
					<p><FormattedMessage id="login.help.paragraph1"/></p>
					<p><FormattedMessage id="login.help.paragraph2"/></p>
					<p><FormattedMessage id="login.help.paragraph3"/></p>
				</div>
			</div>
	</Modal.Modal>
	)
}

export default injectIntl(LoginHelpModal)
